export default "__VITE_ASSET__D0hmfP1M__"